import NucleusKit from "../../../Models/NucleusKit";

export const UpdatePatientFirstName = (nucleusKit: (NucleusKit | null), firstname: string): (NucleusKit | null) => {
    if(nucleusKit === null) {
        return null
    } 
    // nucleusKit.patient.firstName = firstname
    var objectCopy = Object.assign({}, nucleusKit)
    // objectCopy.patient.firstName = firstname
    return {
        ...objectCopy,
    }
};

export const UpdatePatientLastName = (nucleusKit: NucleusKit | null, lastname: string): NucleusKit  | null => {
    if(nucleusKit === null) {
        return null
    } 
    // nucleusKit.patient.lastName = lastname
    var objectCopy = Object.assign({}, nucleusKit)
    // objectCopy.patient.lastName = lastname
    return {
        ...objectCopy,
    }
};

export const UpdatePatientDateOfBirth = (nucleusKit: NucleusKit | null, dateOfBirth: string): NucleusKit | null => {
    if(nucleusKit === null) {
        return null
    } 
    // nucleusKit.patient.dateOfBirth = new Date(dateOfBirth)
    var objectCopy = Object.assign({}, nucleusKit)
    // objectCopy.patient.dateOfBirth = new Date(dateOfBirth)
    return {
        ...objectCopy,
    }
};

export const UpdatePatientGender = (nucleusKit: NucleusKit | null, gender: string): NucleusKit | null => {
    if(nucleusKit === null) {
        return null
    } 
    nucleusKit.gender = gender
    var objectCopy = Object.assign({}, nucleusKit)
    objectCopy.gender = gender
    return {
        ...objectCopy,
    }
};